<!-- 金色标题 -->
<template>
  <div
    class="gold-title"
    :class="extraClass"
    :style="`${width ? `width:${width}px` : ''} ${size ? `font-size: ${size}px` : ''}`"
  >
    <svg
      class="icon"
      aria-hidden="true"
    >
      <use :xlink:href="`#${context}`"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'gold-title',
  props: {
    context: {
      type: String,
      default: ''
    },
    extraClass: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
  .gold-title {
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width:223px;
    height:44px;
    font-size: 96px;
    background: linear-gradient(133deg,#85d784 22%, #00a0e9 84%);
    border-radius:0px 0px 6px 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color:rgba(255,255,255,1);
    &::before, &::after{
      content: '';
      display: block;
      position: absolute;
      width: 0;
      top: 0;
      left: 0;
      height: 0;
      transform: translateX(-100%);
      overflow: hidden;
      font-size: 0;
      line-height: 0;
      border-color:transparent #AA7F56 transparent transparent;
      border-style:solid dashed dashed dashed;
      border-width:6px 6px 0 0 ;
    }
    &::after {
      left: auto;
      right: 0;
      transform: translateX(100%) rotateY(180deg);
    }
  }
  .invite {
    background: linear-gradient(134deg,#3023ae, #c86dd7 100%);
  }
</style>
